<template>
  <div id="input-invoice">
    <b-form inline>
      <label class=" mx-5" for="invoice">เลขที่ใบแจ้งหนี้</label>
      <b-input
        id="invoice"
        v-model="invoiceNumberInput"
        class="col-md-2 mb-2 mr-5 mb-sm-0"
      />
      <label class=" mr-5" for="datepicker-trigger">วันที่ออกเอกสาร</label>
      <div class="date-box">
        <div class="select-box">
          <div
            class="datepicker-trigger input-group"
            @mouseover="activeCloseDate = true"
            @mouseleave="activeCloseDate = false"
          >
            <input
              id="datepicker-trigger"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="เลือกวันที่"
              :value="formatDates(dateSelected)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
                ><fa-icon
                  :style="{
                    opacity: activeCloseDate ? 1 : 0,
                  }"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :date-one="dateInvoice"
              :mode="'single'"
              @date-one-selected="(val) => setDateInvoice(val)"
              @apply="applyDate"
            />
          </div>
        </div>
      </div>
      <b-col cols="2" class="ml-5">
        <b-button
          block
          class="create-document-btn"
          :disabled="!canCreate"
          @click="createInvoice"
        >
          สร้างเอกสาร
        </b-button>
      </b-col>
    </b-form>
  </div>
</template>

<script>
import format from "date-fns/format";
import { mapGetters } from "vuex";

export default {
  name: "InputInvoiceComponent",
  props: {
    invoiceNumber: {
      type: String,
    },
    dateInvoice: {},
    createInvoice: {},
    canCreate: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      orderChecked: "Account/getOrderChecked",
    }),
  },
  watch: {
    invoiceNumberInput(newVal, oldVal) {
      this.$emit("update:invoiceNumber", newVal);
    },
    invoiceNumber(newVal, oldVal) {
      this.invoiceNumberInput = newVal;
    },
  },
  mounted() {
    this.dateSelected = this.dateInvoice;
    this.invoiceNumberInput = this.invoiceNumber;
  },
  data() {
    return {
      activeCloseDate: false,
      dateSelected: null,
      dateFormat: "D/MM/YYYY",
      invoiceNumberInput: "",
    };
  },
  methods: {
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.$emit("update:dateInvoice", null);
      this.dateSelected = null;
    },
    setDateInvoice(val) {
      this.dateSelected = val;
      this.$emit("update:dateInvoice", this.dateSelected);
    },
    applyDate() {
      this.$emit("update:dateInvoice", this.dateSelected);
    },
  },
};
</script>

<style lang="scss" scoped>
.create-document-btn {
  background-color: #009906;
  border: none;

  &:disabled {
    background-color: #999999;
  }
}
</style>
